import {Component, OnDestroy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ContactRequest} from "../../model/contact-request";
import {BusinessService} from "../../services/data/business.service";
import {NotificationsService} from "angular2-notifications/components";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Subscription} from "rxjs";

@Component({
  selector: 'help-page',
  template: require('./help-page.component.html'),
  styles: [
    require('./help-page.component.scss')
  ]
})

export class HelpPageComponent implements OnDestroy {

  tab: string = 'question';

  model: ContactRequest = new ContactRequest();

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  constructor(private activatedRoute: ActivatedRoute, private businessService: BusinessService,
              private notificationService: NotificationsService, private currentBusinessService: CurrentBusinessService) {
    this.paramSubscription = activatedRoute.params.subscribe(
      (param: any) => {
        let tab = param['tab'];

        if (tab != null && tab != '') {
          this.tab = tab;
        } else {
          this.tab = 'question';
        }
      }
    );
  }

  contactUsButton() {
    this.tab = 'contact';
  }

  cancelContact() {
    this.tab = 'question';
  }

  sendContactMessage() {
    this.businessService.sendOnlineContact(this.model, this.currentBusinessService.currentBusiness.id).subscribe(
      response => {
        this.notificationService.success('Contact', 'Votre demande a bien été envoyé à l\'équipe de support');
        this.model = new ContactRequest();
      }
    )
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/help/help-page.component.ts